import type { UseFetchOptions } from "nuxt/app";

/**
 * `useFetch` bound to `$larafetch`, so SSR cookie forwarding, CSRF and error
 * handling all come from the one place.
 *
 * Error toasts live in `$larafetch` alone. This used to add a second
 * `onResponseError` of its own, and ofetch runs the instance hook *and* the
 * per-call hook — so every failed request showed the visitor the same message
 * twice. The two also disagreed on what to read: `$larafetch` looks at the
 * HTTP status, while this one looked at the `code` field in the body.
 */
export function useLarafetch<T>(
  url: string | (() => string),
  options: UseFetchOptions<T> = {}
) {
  return useFetch(url, {
    $fetch: $larafetch,
    ...options,
  });
}
